import React from "react";

export default function TopTopics({ topics = [] }) {
  if (!topics.length) {
    return (
      <section className="dash-card">
        <div className="dash-card-header">
          <h2 className="dash-card-title">Top conversation topics</h2>
        </div>
        <p className="dash-empty">No topics for this period yet.</p>
      </section>
    );
  }

  return (
    <section className="dash-card">
      <div className="dash-card-header">
        <h2 className="dash-card-title">Top conversation topics</h2>
      </div>

      <ul className="dash-topics">
        {topics.map((topic) => (
          <li key={topic.label}>
            <div className="dash-topics-row">
              <span>{topic.label}</span>
              <span>{topic.percent}%</span>
            </div>
            <div className="dash-topics-track">
              <span style={{ width: `${topic.percent}%` }} />
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
